var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":_vm.target},on:{"click":function (e) { return this$1.$emit('click', e); },"mouseover":function (e) { return this$1.$emit('mouseover', e); },"mouseenter":function (e) { return this$1.$emit('mouseenter', e); },"mouseleave":function (e) { return this$1.$emit('mouseleave', e); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }